module.exports = __webpack_public_path__ + "Roboto-LightItalic.cdd1c486770034a6122e.eot";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-LightItalic.eot
// module chunks = 16